module.exports = __webpack_public_path__ + "static/media/corner_bg.89bc378d.svg";